export default __webpack_public_path__ + "static/media/edo-project.216fb2af.png";